import { render } from "./ShockTraumatologyClinicPage.vue?vue&type=template&id=ecc73362"
import script from "./ShockTraumatologyClinicPage.vue?vue&type=script&lang=js"
export * from "./ShockTraumatologyClinicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__